<img [src]="bigImage" onerror="this.src='assets/images/products/noImage/no-image.png';"
style="width: 90%">